var exports = {
  "k": "xae11d333--0cf88b--container",
  "I": "xae11d333--0cf88b--seo-text",
};

module.exports = exports;
